// extracted by mini-css-extract-plugin
export var breadcrumb = "_3-0";
export var breadcrumbArrow = "_3-1";